module.exports = __webpack_public_path__ + "img/img_bg1_home.d4a0a189.png";